import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import './App.css';
import InputMask from 'react-input-mask'; 
import AppSettings from './App.json'

class NeedMoreHelp extends Component {

    constructor(props) {
        super(props)
        this.state = {
          resultMessage: "",
          errorMessage: "",
          firstName: "",
          lastName: "",
          emailAddress: "",
          mobilePhone: "",
          comments: "",
        };
        this.FirstName = React.createRef()
        this.LastName = React.createRef()
        this.EmailAddress = React.createRef()
        this.MobilePhone = React.createRef()
        this.Comment = React.createRef()
        this.resultMessage = React.createRef();
      }

    componentDidMount() {
        console.log('NeedMoreHelp::componentDidMount')
        this.setState({resultMessage: "", errorMessage: ""})
    }

    SubmitRequest = () => {
      console.log('NeedMoreHelp::SubmitRequest')
      if (this.ValidateFields()) {
        this.SaveNeedMoreHelp();
      }
    }

    ValidateFields = () => {
      console.log('NeedMoreHelp::ValidateFields')
      let valid = true;
      if (this.state.firstName === "") 
      { 
          this.FirstName.current.className += ' invalidInput'
          valid = false
      } 
      else 
      {
        this.FirstName.current.className = 'formFieldLabel'
      }
      if (this.state.lastName === "") 
      { 
          this.LastName.current.className += ' invalidInput'
          valid = false
      } 
      else 
      {
        this.LastName.current.className = 'formFieldLabel'
      }
      if (this.state.emailAddress === "") 
      { 
          this.EmailAddress.current.className += ' invalidInput'
          valid = false
      } 
      else 
      {
        this.EmailAddress.current.className = 'formFieldLabel'
      }
      if (this.state.mobilePhone === "") 
      { 
        this.MobilePhone.current.className = ' invalidInput'
          valid = false
      } 
      else 
      {
        this.MobilePhone.current.className = 'formFieldLabel'
      }
      if (valid) {
        this.setState({resultMessage: "", errorMessage: ''})
      } else {
        this.setState({resultMessage: "", errorMessage: 'Please completed all required fields.'})
      }
      return valid
    }

    OnChangeFirstName = (e) => {
      console.log('GroupDetail::OnChangeFirstName')
      this.setState({
        firstName: e.target.value,
      })
    }

    OnChangeLastName = (e) => {
      console.log('GroupDetail::OnChangeLastName')
      this.setState({
        lastName: e.target.value,
      })
    }

    OnChangeEmailAddress = (e) => {
      console.log('GroupDetail::OnChangeEmailAddress')
      this.setState({
        emailAddress: e.target.value,
      })
    }

    OnChangeMobilePhone = (e) => {
      console.log('GroupDetail::OnChangeMobilePhone')
      this.setState({
        mobilePhone: e.target.value,
      })
    }

    OnChangeComments = (e) => {
      console.log('GroupDetail::OnChangeComments')
      this.setState({
        comments: e.target.value,
      })
    }

    SaveNeedMoreHelp = () => {
      console.log('NeedMoreHelp::SaveNeedMoreHelp')
      let _url = AppSettings.SERVER_URL + '/API/SaveNeedMoreHelp'
      //let _data = { firstName: this.FirstName.current.value, lastName: this.LastName.current.value, emailAddress: this.EmailAddress.current.value, mobilePhone: this.MobilePhone.current.value, comment: this.Comment.current.value }
      let _data = { firstName: this.state.firstName, lastName: this.state.lastName, emailAddress: this.state.emailAddress, mobilePhone: this.state.mobilePhone, comment: this.state.comments }
      fetch(_url, { 
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(_data)
        })
        .then(async response => { 
          const data = await response.json()
          if (data.status === "Success") {
              this.setState({resultMessage: 'Saved Successfully.'})                
          } else {
              this.setState({errorMessage: 'Error occurred during save.'})
          }
        })
        .catch(error => {
          console.error('NeedMoreHelp::SaveNeedMoreHelp: There was an error!', error)
        });

    }

    closeClicked = () => {
        this.props.history.push('/SmallGroupWidget/groups')
    }

    render() {
        return (
            <div>
                <div className='backLinkDiv'>
                  <button className='backLink' onClick={()=>{this.closeClicked()}} >&#129056;&nbsp;Back to Groups Listing</button>  
                </div>
                <div className="groupDetailDiv">
                <div className='signUpForm'>
                      <div className='signUpFormInstructions'>
                        <b>Instructions:</b>&nbsp;If you are unable to find a group using search, fill out the form below and someone will get in touch with you and help you better streamline your interests.
                      </div>
                      <div className='detailFormFieldDiv'>
                        <span className='formFieldLabel' ref={this.FirstName}>Firstname</span>
                        <input data-superscript="8" className='form-control' value={this.state.firstName} onChange={this.OnChangeFirstName} ></input>
                      </div>
                      <div className='detailFormFieldDiv'>
                        <span className='formFieldLabel' ref={this.LastName}>Lastname</span>
                        <input className='form-control' value={this.state.lastName} onChange={this.OnChangeLastName}></input>
                      </div>
                      <div className='detailFormFieldDiv'>
                        <span className='formFieldLabel' ref={this.EmailAddress}>Email</span>
                        <input className='form-control' value={this.state.emailAddress} onChange={this.OnChangeEmailAddress}></input>
                      </div>
                      <div className='detailFormFieldDiv'>
                        <span className='formFieldLabel' ref={this.MobilePhone}>Mobile</span>
                        <InputMask className='form-control' value={this.state.mobilePhone} mask="999-999-9999"  maskChar=""  onChange={this.OnChangeMobilePhone} />
                      </div>
                      <div className='detailFormFieldDiv'>
                        <span className='formFieldLabel' ref={this.Comment}>Comment</span>
                        <textarea className='form-control' value={this.state.comments} onChange={this.OnChangeComments} ></textarea>
                      </div>
                      <div className="joinButtonDiv">
                        <button className='joinButton' onClick={()=>this.SubmitRequest()}>Request Assistance</button>
                        <div className='resultMessageDiv'>
                          <span className='resultMessage'>{this.state.resultMessage}</span>
                          <span className='errorMessage'>{this.state.errorMessage}</span>
                        </div>
                      </div>     
                    </div>
            </div>
            </div>
        )
    }
}

export default withRouter(NeedMoreHelp)